import {
  ShelfPatternEnum,
  ShelfPositionEnum,
  ShelfProductPatternEnum,
  ShelfStyleEnum,
} from 'src/interfaces';

import { COMMON_GCF_COMPONENT_CONFIG } from './gcfComponentCommonConfig';

export const SINGLE_SHELF_COMPONENT_CONFIG = {
  ...COMMON_GCF_COMPONENT_CONFIG,
  lineupStyle: {
    type: ShelfStyleEnum.STAGGERED,
    order: ShelfProductPatternEnum.DEFAULT,
    pattern: ShelfPatternEnum.FROM_TOP,
    position: ShelfPositionEnum.CENTER,
  },
};
